import { CVHero, Connect } from '@/components/sections/portfolio'
import { FeaturedWork, CareerSnapshot, WorkingMethod, FeaturedWriting } from '@/components/sections/portfolio/HomeHighlights'
import { References } from '@/components/sections/cv/References'
import { SEO } from '@/components/shared/SEO'
import { identity } from '@/content/portfolio'

export function Home() {
  return (
    <>
      <SEO title={`${identity.fullName} — ${identity.title}`} description="Senior Technical Product Manager and AI-native product builder turning complex workflows into usable products across discovery, prototyping, and delivery." url={identity.website} />
      <main id="main-content" tabIndex={-1}>
        <CVHero />
        <FeaturedWork />
        <CareerSnapshot />
        <WorkingMethod />
        <References preview />
        <FeaturedWriting />
        <Connect />
      </main>
    </>
  )
}
